<template>
  <div>
    <apexchart height="220" style="height: 100px; width: 100%; background-color: transparent;" type="donut"
      :options="chartOptions" :series="series">
    </apexchart>
  </div>
</template>

<script>
var mydata = [0, 0, 0, 0, 0];

const totaldata = (e) => {
  return e.reduce((a, b) => a + b, 0);
};

export default {
  props: {
    parseData: {
      type: Object,
      default: () => { },
    },
  },

  data() {
    return {
      series: mydata,

      chartOptions: {
        chart: {
          type: "donut",
        },

        colors: [
          "#FF4560",
          "#008FFB",
          "#00E396",
          "#FEB019",
          "#775DD0",
        ],

        labels: [
        ],

        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => totaldata(mydata),
                },
              },
            },
          },
        },

        legend: {
          show: true,
          position: "right",
        },
      },
    };
  },

  mounted() {
    this.updateChart();

  },

  watch: {
    parseData: {
      handler() {
        this.updateChart();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    updateChart() {
      //console.log(this.parseData.list_jum)
      if (this.parseData) {
        this.series = this.parseData.list_jum;
        
        this.chartOptions = {
          ...this.chartOptions,
          labels: [...this.parseData.list_nama]
        };
        mydata = this.parseData.list_jum

        console.log(this.parseData.list_nama)
      } else {
        this.series = [
          {
            name: "Jumlah Tiket",
            data: new Array(12).fill(0),
          },
        ];
      }
    },
  },
};
</script>
